import PropTypes from 'prop-types';
import CommsTypes from '../constants/CommsTypes';
import EmailParticipantTypes from '../constants/EmailParticipantTypes';

export const EmailAttachmentPropType = PropTypes.shape({
  contentType: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  fileLocator: PropTypes.string.isRequired,
  s3Url: PropTypes.string.isRequired,
});

export const EmailParticipantPropType = PropTypes.shape({
  constituentId: PropTypes.string,
  displayName: PropTypes.string,
  emailAddress: PropTypes.string.isRequired,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  resourceType: PropTypes.oneOf(Object.values(EmailParticipantTypes)),
  userId: PropTypes.string,
});

export const EmailIntegrationFeedDetailsPropType = PropTypes.shape({
  bccRecipients: PropTypes.arrayOf(EmailParticipantPropType),
  commsId: PropTypes.string.isRequired,
  ccRecipients: PropTypes.arrayOf(EmailParticipantPropType),
  messageDateTime: PropTypes.string.isRequired,
  sender: EmailParticipantPropType.isRequired,
  toRecipients: PropTypes.arrayOf(EmailParticipantPropType).isRequired,
});

export const CommsResponsePropType = PropTypes.shape({
  attachments: PropTypes.arrayOf(EmailAttachmentPropType),
  body: PropTypes.string.isRequired,
  bccRecipients: PropTypes.arrayOf(EmailParticipantPropType),
  ccRecipients: PropTypes.arrayOf(EmailParticipantPropType),
  commsId: PropTypes.string.isRequired,
  commsType: PropTypes.oneOf(Object.values(CommsTypes)).isRequired,
  conversationId: PropTypes.string.isRequired,
  created: PropTypes.string.isRequired,
  messageDatetime: PropTypes.string.isRequired,
  messageId: PropTypes.string.isRequired,
  ownerOrgId: PropTypes.string.isRequired,
  sender: EmailParticipantPropType.isRequired,
  subject: PropTypes.string.isRequired,
  toRecipients: PropTypes.arrayOf(EmailParticipantPropType).isRequired,
  updated: PropTypes.string.isRequired,
});
